package com.ervasstudio.tracoemovimento.pages.cursos.meuscursos

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.model.Paginas
import com.huanshankeji.compose.html.material3.MdCircularProgress
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun MeusCursos() {
    val auth = Firebase.auth
    var isLoading by remember { mutableStateOf(true) }
    var isLoggedIn by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()


    LaunchedEffect(Unit) {
        delay(2000)
        val currentUser = auth.currentUser
        if (currentUser != null) {
            println("Usuário já está logado: ${currentUser.email}")
            isLoading = false
            isLoggedIn = true
            // Redireciona para o Dashboard / Home
        } else {
            ctx.router.navigateTo(Paginas.LOGIN.rota)
        }

    }

    /*LaunchedEffect(Unit) {
        auth.authStateChanged.collect { user ->
            isLoggedIn = (user != null)
            if (!isLoggedIn) {
                // isLoading = true
            } else {
                // isLoading = false
            }
            // O Firebase terminou de checar o storage do navegador
        }
        }
        */


    /* if (isLoading) {
         // Mostra um spinner ou tela em branco enquanto verifica o IndexedDB
         Text("Carregando sessão...")
     } else {
         if (isLoggedIn) {
             // Conteúdo protegido (Dashboard / Home)
             Text("Bem-vindo de volta! ${auth.currentUser?.email}.")
         } else {
             // Tela de Login / Signup
         }
     }

     Column(modifier = Modifier.fillMaxSize()) {
         MdLinearProgress(indeterminate = true)
         MdCircularProgress(indeterminate = true)
     }*/

    if (isLoading) {
        LoadingPage()
    } else {

    }

}

@Composable
fun LoadingPage() {

    Column(Modifier.fillMaxWidth().fillMaxHeight(), Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally) {
        MdCircularProgress(indeterminate = true)
    }


}